module.exports = __webpack_public_path__ + "be4040fd919dc7a1844534a852a44c59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/PowerWhite.jpg
// module id = 1290
// module chunks = 0